import css from 'styled-jsx/css';

export default css`@charset "UTF-8";
.info {
  color: #414141;
  background-color: #fff; }
  .info__addr {
    width: 100%;
    color: #414141;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer; }
  .info a {
    width: 100%;
    color: #414141;
    display: flex;
    justify-content: space-between;
    align-items: center; }
  .info__spaceBetween {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px; }
  .info__gray {
    background: #f5f5f5; }
  .info__name {
    display: inline-block;
    vertical-align: middle;
    font-size: 24px;
    font-weight: normal;
    letter-spacing: 0.4px; }
  .info__clap {
    display: inline-block;
    height: 20px;
    font-size: 14px;
    line-height: 20px;
    vertical-align: middle;
    cursor: pointer; }
    .info__clap::before {
      content: '';
      display: inline-block;
      width: 20px;
      height: 20px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url(https://static.popdaily.com.tw/img/globalicon/clap.png?0425);
      vertical-align: middle; }
  .info__clapScore {
    display: inline-block;
    margin-left: 4px;
    vertical-align: middle;
    font-size: 14px;
    color: #7d7af4; }
  .info__openMap {
    padding: 12px;
    border-radius: 4px;
    background-color: #7d7af4;
    color: #fff;
    font-size: 14px; }
  .info__detailRow {
    border-top: 1px solid #eee; }
  .info__subtitle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    padding-top: 0;
    font-size: 14px; }
    .info__subtitle__left {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center; }
    .info__subtitle__item {
      margin-left: 5px; }
    .info__subtitle__couponBtn {
      width: 82px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      background-image: linear-gradient(116deg, #7d7af4, #838eff);
      cursor: pointer; }
    .info__subtitle__couponBtnIcon {
      width: 18px;
      height: 18px; }
    .info__subtitle__couponBtnText {
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.14;
      letter-spacing: normal;
      text-align: center;
      color: #fff; }
  .info__average {
    font-size: 14px; }
  .info__detailTitle {
    margin-bottom: 4px;
    font-size: 16px;
    font-weight: 500; }
  .info__detailTitle--new::after {
    content: 'New!';
    display: inline-block;
    margin-left: 4px;
    font-size: 12px;
    letter-spacing: 0.4px;
    color: #7d7af4; }
  .info__detailContent {
    font-size: 14px;
    line-height: 1.71;
    letter-spacing: 0.4px;
    white-space: pre-wrap; }
  .info__detailAccessory {
    background-image: url(../statics/images/icon/keyboard_arrow_right_black.svg);
    width: 24px;
    height: 24px; }
  .info__verticalRightBorder {
    flex-grow: 1;
    border-right: 1px solid #eee; }
  .info__rnMapBtn {
    background-image: url(../statics/images/icon/location.svg);
    background-size: 24px 24px;
    background-repeat: no-repeat;
    background-position: center;
    object-position: center;
    width: 24px;
    height: 48px;
    margin-left: 22px;
    margin-right: 22px;
    padding-right: 22px; }
  .info__openStatus--open::before {
    content: '營業中，';
    color: #62d167; }
  .info__openStatus--close::before {
    content: '休息中，';
    color: #ff8383; }
  .info__pointer {
    cursor: pointer; }
  .info__ghostRNMapBtn {
    height: 48px;
    border-radius: 4px;
    background-color: #838eff;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1; }
  .info__ghostComment {
    display: flex;
    align-items: center; }
  .info__ghostQuestion {
    cursor: pointer;
    margin-left: 8px;
    width: 24px;
    height: 24px;
    object-fit: contain; }
`